<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <div class="active section">Relatório para seguro de vida.</div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div ref="modal" class="ui large modal" style="top: 40px">
        <iframe
          ref="viewer"
          width="100%"
          style="height: calc(100vh - 100px)"
        ></iframe>
      </div>
      <form
        :class="['ui small', { error: anyError }, 'form']"
        v-autocomplete-off
      >
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="ten wide column">
              <div class="five wide field">
                <label for="insurance-report-overdue-since">
                  Tempo de inadimplência (por mês)
                </label>
                <input
                  type="text"
                  id="insurance-report-overdue-since"
                  v-model="form.overdue_since"
                />
              </div>

              <div class="field">
                <label for="insurance-report-plans"> Planos </label>
                <select
                  id="insurance-report-plans"
                  class="ui fluid search dropdown"
                  multiple=""
                  v-model="form.plans"
                >
                  <option
                    v-for="(plan, index) in plans"
                    :key="index"
                    :value="plan.id"
                  >
                    {{ plan.description }} - {{ plan.id }}
                  </option>
                </select>
              </div>
              <div class="five wide field">
                <label for="insurance-report-format"> Formato </label>
                <select
                  id="insurance-report-format"
                  class="ui dropdown"
                  v-model="form.format"
                >
                  <option
                    v-for="(format, index) in formats"
                    :key="index"
                    :value="format"
                  >
                    {{ format }}
                  </option>
                </select>
              </div>
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="run"
                  type="button"
                  name="run"
                  class="ui submit blue button"
                >
                  <i class="play icon"></i>Gerar Relatório
                </button>
              </div>
            </div>
          </div>
          <!-- row -->
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import ContractEnum from '@/enumerations/contract_enum';

export default {
  components: { Breadcrumb, PageLayout },

  data() {
    return {
      loading: false,
      loaded: false,
      errors: {},
      collaborators: [],
      plans: [],
      formats: ['pdf', 'xls'],
      form: {
        plans: [],
        overdue_since: null,
        format: 'pdf'
      },
      states: ContractEnum.states
    };
  },

  computed: {
    anyError() {
      return !_.isEmpty(this.errors);
    }
  },

  mounted() {
    this.getData();

    $('.ui.dropdown').dropdown();
  },

  methods: {
    async getData() {
      this.loading = true;

      const plansQuery = {
        q: {
          enable_eq: true,
          s: ['id asc']
        }
      };

      try {
        const plansResponse = await Api.plans.search(plansQuery);
        this.plans = _.clone(plansResponse.data.plans);
      } catch (e) {
        this.$toast.show('Erro ao carregar dados', 'error');
        throw e;
      } finally {
        this.loading = false;
      }
    },

    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    download(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        const a = document.createElement('a');
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 0);
      }
    },

    run() {
      this.loading = true;
      let data = {
        report: 'insurance'
      };

      if (this.form.plans.length > 0) {
        data.PLAN_IDS = this.form.plans.join(',');
      }

      if (!_.isEmpty(this.form.overdue_since)) {
        data.OVERDUE_SINCE = this.form.overdue_since;
      }

      data.report_type = this.form.format;

      Api.report(data)
        .then(response => {
          if (data.report_type == 'pdf') {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            $(this.$refs.viewer).attr('src', window.URL.createObjectURL(blob));
            $(this.$refs.modal).modal('show');
          } else {
            const blob = new Blob([response.data], {
              type: `application/${data.report_type}`
            });
            this.download(blob, `relatorio_seguro_vida.${data.report_type}`);
          }
        })
        .catch(error => {
          this.showError = true;
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
